import { render, staticRenderFns } from "./AccessVersionsModal.vue?vue&type=template&id=fbba41bc&scoped=true&"
import script from "./AccessVersionsModal.vue?vue&type=script&lang=ts&"
export * from "./AccessVersionsModal.vue?vue&type=script&lang=ts&"
import style0 from "./AccessVersionsModal.vue?vue&type=style&index=0&id=fbba41bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbba41bc",
  null
  
)

export default component.exports